import { ROUTES } from "config/routes";
import { ICONS_LABEL } from "shared/constants/icons";

const user = [
  {
    name: "File Manager",
    submenu: [
      {
        name: "My Videos",
        url: ROUTES.VIDEOS,
        icon: ICONS_LABEL.CloudDoneOutlined,
      },
      {
        name: "Reports",
        url: ROUTES.REPORTS,
        icon: ICONS_LABEL.AssessmentOutlined,
      },
      {
        name: "Downloads",
        url: ROUTES.DOWNLOADS,
        icon: ICONS_LABEL.CloudDownloadOutlined,
      },
    ],
  },
];

export default user;
